import { render, staticRenderFns } from "./SidebarGroupLabel.vue?vue&type=template&id=5c124491&scoped=true&"
import script from "./SidebarGroupLabel.vue?vue&type=script&lang=ts&"
export * from "./SidebarGroupLabel.vue?vue&type=script&lang=ts&"
import style0 from "./SidebarGroupLabel.vue?vue&type=style&index=0&id=5c124491&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c124491",
  null
  
)

export default component.exports